module.exports = __webpack_public_path__ + "static/media/genetics.9dbd6fe2.png";